import { useMemo } from 'react';

import type { IncidentType } from '@/types';

import { processIncidentPeriods } from '@/utils/helpers/process-incident-periods';

export const useIncidentTiming = (periods: IncidentType['activePeriod'], isListItem?: boolean) => {
  return useMemo(() => {
    if (!periods?.length) {
      return { groupedPeriods: [] };
    }

    const now = new Date();
    const groupedPeriods = processIncidentPeriods(periods, now);

    return {
      groupedPeriods: isListItem ? groupedPeriods.slice(0, 2) : groupedPeriods,
    };
  }, [periods, isListItem]);
};
